import { Box, Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import VectorUp from 'assets/images/vector_up.png';
import Down from 'assets/icons/down.svg';
import { poppins600 } from 'theme/common.style';
import { useState, useEffect } from 'react';
import GaugeComponent from 'react-gauge-component';

function MeterGaugeChart({ sector }) {
  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  const [highest, setHighest] = useState();
  const [lowest, setLowest] = useState();
  const [indicator, setIndicator] = useState();
  const [variance, setVariance] = useState();
  const formatAmount = (value) => {
    return `$${Math.round(Number(value)).toLocaleString('en-US')}`;
  };

  useEffect(() => {
    sector?.leftColumn?.map((keys, index) => {
      if (keys.key == 'Campaign Highest Offers') {
        setHighest(keys.value);
      } else if (keys.key == 'Campaign Lowest Offers') {
        setLowest(keys.value);
      } else if (keys.key == 'Indicator') {
        setIndicator(keys.value);
      } else if (keys.key == 'Variance') {
        setVariance(keys.value);
      } else {
      }
    });
  }, []);

  return (
    <Grid
      sx={{
        display: 'flex',
        paddingTop: '5px',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        minWidth: '100%',
      }}
    >
      <Card
        style={{
          borderRadius: '8px',
          padding: '15px',
          margin: '10px',
          height: '100%',
          boxShadow: 'none',
          minWidth: '98%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ffff',
          gap: '10px',
        }}
      >
        <Grid>
          <Typography
            sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
          >
            Offer range comparison to Market
          </Typography>
        </Grid>
        <Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
            }}
          >
            <Typography
              sx={{ fontFamily: 'poppins', fontSize: '16px' }}
            ></Typography>
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'end',
              }}
            >
              <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: 600,
                    fontSize: '22px',
                    color: indicator == 'negative' ? 'red' : '#10D35E',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {variance}
                </Typography>
                <Typography>
                  <img
                    src={indicator == 'negative' ? Down : VectorUp}
                    alt="vector"
                  />
                </Typography>
              </Typography>
              <Typography sx={{ fontFamily: 'poppins', fontSize: '14px' }}>
                Market Variance
              </Typography>
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                width: '90%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <GaugeComponent
                type="semicircle"
                value={70} // percent={0.7} => value={70}
                labels={{
                  valueLabel: {
                    hide: true,
                  },
                  tickLabels: {
                    hideMinMax: true,
                  },
                }}
                arc={{
                  width: 0.15,
                  padding: 0,
                  subArcs: [
                    { limit: 10, color: '#90e0ef' },
                    { limit: 20, color: '#90e0ef' },
                    { limit: 30, color: '#90e0ef' },
                    { limit: 40, color: '#00b4d8' },
                    { limit: 50, color: '#00b4d8' },
                    { limit: 60, color: '#00b4d8' },
                    { limit: 70, color: '#00b4d8' },
                    { limit: 80, color: '#0077b6' },
                    { limit: 90, color: '#0077b6' },
                    { limit: 100, color: '#0077b6' },
                  ],
                }}
                pointer={{
                  color: '#03045e',
                  length: 0.75,
                  width: 12,
                  elastic: true,
                  animate: true,
                }}
              />
            </Box>
          </Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Typography sx={{ fontSize: '24px', fontFamily: 'poppins' }}>
              {' '}
              {formatAmount(lowest)}
            </Typography>
            <Typography sx={{ fontSize: '24px' }}>-</Typography>
            <Typography sx={{ fontSize: '24px', fontFamily: 'poppins' }}>
              {' '}
              {formatAmount(highest)}
            </Typography>
          </Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <Typography fontFamily={'poppins'}>Min</Typography>
            <Typography fontFamily={'poppins'}>Max</Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

export default MeterGaugeChart;
